import css from 'styled-jsx/css';

const styles = css.global`.error-message .error-icon {
  margin: 0 auto;
  display: block;
}

.error-message .title {
  font-family: 'SantanderText';
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  margin: 0;
  color: #222;
  margin: 11px auto;
}

.error-message .description {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #222;
  margin: 0 0 40px;
}

.error-message .sn-button.white {
  margin-bottom: 16px;
}

.error-message {
  padding-bottom: 200px;
}

.modal-component .modal-surface.modal-simulation-error {
  height: auto;
  min-height: unset;
}

.modal-component .modal-surface.modal-simulation-error .error-message {
  padding-bottom: 0;
}

@media (min-width: 992px) {
  .error-message {
    max-width: 420px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .error-message > .ctn-home-24 {
    padding: 0;
  }

  .error-message .sn-button {
    max-width: 272px;
    margin-left: auto;
    margin-right: auto;
  }
}
`;

export default styles;